import { Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  FormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { AuthService } from '../../_services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { clickGAEvent, pageLoadEvent } from 'src/app/_helpers/ga-events';
import { addGAEventListener } from 'src/app/_helpers/ga-events';
import { removeGAEventListener } from 'src/app/_helpers/ga-events';
import * as Sentry from '@sentry/angular-ivy';
declare var zcAction: any;

@Component({
  selector: 'tp-forget',
  templateUrl: './forget.component.html',
  styleUrls: ['./forget.component.css'],
})
export class ForgetComponent implements OnInit {
  validateForm!: UntypedFormGroup;
  submitted = false;
  infobox = true;
  errmsg: any;
  tenant: boolean = false;
  logo: any;

  constructor(
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.checkIfTenant();
    pageLoadEvent('auth-forgot-password_page');
    addGAEventListener();
    this.infobox = true;
    this.validateForm = this.fb.group({
      email: [null, [Validators.email, Validators.required]],
    });
  }

  ngAfterViewInit(): void {
    removeGAEventListener();
    addGAEventListener();
  }

  ngOnDestroy(): void {
    removeGAEventListener();
  }

  get f() {
    return this.validateForm.controls;
  }
  checkIfTenant() {
    let getLink = window.location.href;
    const { hostname } = new URL(getLink);

    const isTenant = localStorage.getItem('tenant');
    if (isTenant === 'true') {
      this.tenant = true;
      this.logo =
        hostname === 'fidelity-cpaas.terragonltd.com'
          ? '../../../assets/icons/fidelity.svg'
          : hostname === 'oxygen-cpaas.terragonltd.com'
          ? '../assets/icons/oxygen.svg'
          : hostname === 'abstaging-cpaasdev.terragoncpaas.com'
          ? '../assets/icons/access.svg'
          : hostname === 'ocpaasstaging.terragonbase.com' ||
            hostname === 'acc-cpaas.terragonltd.com'
          ? '../assets/icons/terragonLogo.svg'
          : hostname === 'aramex.terragoncpaas.com'
          ? '../assets/icons/aramex.svg'
          : hostname === 'hydrogencpaas.terragoncpaas.com'
          ? '../assets/icons/hydrogen.svg'
          : '../assets/icons/user-dummy.png';
    } else {
      this.tenant = false;
      this.logo = '../../../assets/icons/terragonLogo.svg';
    }
  }

  submitForm() {
    this.submitted = true;
    for (const i in this.validateForm.controls) {
      if (this.validateForm.controls.hasOwnProperty(i)) {
        this.validateForm.controls[i].markAsDirty();
        this.validateForm.controls[i].updateValueAndValidity();
      }
    }

    this.authService.resetPassword(this.f.email.value).subscribe(
      (data) => {
        zcAction('forget_password');
        this.infobox = false;
        this.errmsg = data.response;
      },
      (error: any) => {
        Sentry.captureMessage('Error: ' + error);
      }
    );
  }

  triggerGAClick(buttonName: string): void {
    if (buttonName === 'back-to-login') {
      clickGAEvent(
        'button_click',
        'back-to-login_click',
        'auth-forgot-password_page'
      );
      this.router.navigate(['/auth/login']);
    }
    if (buttonName === 'send-password-instructions') {
      clickGAEvent(
        'button_click',
        'send-password-instructions_click',
        'auth-forgot-password_page'
      );
    }
  }
}
